import PythonApi from '@/services/PythonApi';

export default {
    async download(payload) {
        const url = "report/download", params = new URLSearchParams();
        if (payload) {
            if (payload.fromDate)
                params.append('from_date', payload.fromDate);
            if (payload.toDate)
                params.append('to_date', payload.toDate);
            if (payload.cow_ids)
                payload.cow_ids.forEach(cow_id => params.append('cow_ids', cow_id))
            if (payload.report_type)
                params.append('report_type', payload.report_type);
        }
        const response = await PythonApi().get(url, params)

        // Handle file download

        // Check if to date is empty, if so, set it to current date
        if (!payload.toDate)
            payload.toDate = (new Date()).toISOString().split('.')[0];
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(new Blob([response.data]));;
        link.setAttribute(
            'download',
            `report_${payload.fromDate}-${payload.toDate}.csv`
        );
        document.body.appendChild(link);
        link.click();

        return response;
    }
}


// WEBPACK FOOTER //
// ./src/services/ReportService.js